const checks = [
    ...document.querySelectorAll('.vp-block-references-list .check input'),
]

if (checks.length) {
    const url = new URL(document.location.toString())
    url.hash = 'list'

    for (const check of checks) {
        check.addEventListener('input', () => {
            url.searchParams.delete('thematique')
            const checked = checks
                .filter((el) => el.checked)
                .map((el) => el.value)
            if (checked.length) {
                url.searchParams.set('thematique', checked.join(','))
                url.pathname = url.pathname.replace(/page\/\d+\/$/, '')
            }
            document.location.href = url.toString()
        })
    }
}
